
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-search",
      function () {
        return require("private-next-pages/content-search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-search"])
      });
    }
  